var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLearningAdaptiveWrongBottom = function SvgLearningAdaptiveWrongBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FB5058"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2256,
    cy: 10.5735,
    r: 3.79076,
    fill: "#FF8484"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2678 19.2666C19.9131 18.6214 20.9592 18.6214 21.6044 19.2666L23.7405 21.4027L25.8765 19.2666C26.5218 18.6214 27.5679 18.6214 28.2131 19.2666C28.8583 19.9118 28.8583 20.9579 28.2131 21.6032L26.077 23.7392L28.2131 25.8753C28.8583 26.5205 28.8583 27.5666 28.2131 28.2118C27.5679 28.8571 26.5218 28.8571 25.8765 28.2118L23.7405 26.0758L21.6044 28.2118C20.9592 28.8571 19.9131 28.8571 19.2678 28.2118C18.6226 27.5666 18.6226 26.5205 19.2678 25.8753L21.4039 23.7392L19.2678 21.6032C18.6226 20.9579 18.6226 19.9118 19.2678 19.2666Z",
    fill: "white"
  })));
};
export default SvgLearningAdaptiveWrongBottom;